export default "__VITE_ASSET__CdV0PwFZ__"